(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jigzy-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jigzy-bundle-builder')) {
    customElements.define('jigzy-bundle-builder', class extends HTMLElement {
      connectedCallback() {
        this.picks = new Map();
        this.buttons = [...this.querySelectorAll('[data-pick]')];
        this.addButton = this.querySelector('[data-add]');
        this.variantSelectors = [...this.querySelectorAll('[data-variant-select]')];
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'INR',
          maximumFractionDigits: 0
        });
        this.buttons.forEach((button) => button.addEventListener('click', () => this.select(button)));
        this.variantSelectors.forEach((select) => select.addEventListener('change', () => this.changeVariant(select)));
        this.addButton.addEventListener('click', () => this.addBundle());
      }

      select(button, shouldAdvance = true) {
        const category = button.dataset.category;
        this.querySelectorAll(`[data-pick][data-category="${category}"]`).forEach((item) => item.setAttribute('aria-pressed', 'false'));
        button.setAttribute('aria-pressed', 'true');
        this.picks.set(category, {
          id: Number(button.dataset.variantId),
          title: button.dataset.variantTitle ? button.dataset.title + ' — ' + button.dataset.variantTitle : button.dataset.title,
          image: button.dataset.image,
          price: Number(button.dataset.price)
        });
        const update = () => this.render(category, shouldAdvance);
        if (document.startViewTransition) {
          document.startViewTransition(update);
        } else {
          update();
        }
      }

      changeVariant(select) {
        const option = select.selectedOptions[0];
        const card = select.closest('[data-product-card]');
        const button = card.querySelector('[data-pick]');
        button.dataset.variantId = option.value;
        button.dataset.price = option.dataset.price;
        button.dataset.image = option.dataset.image || '';
        button.dataset.variantTitle = option.dataset.colour || '';
        const productImage = button.querySelector('.jbb__product-image img');
        if (productImage && option.dataset.image) {
          productImage.removeAttribute('srcset');
          productImage.src = option.dataset.image;
        }
        button.querySelector('[data-product-price]').textContent = this.money.format(Number(option.dataset.price) / 100);
        if (button.getAttribute('aria-pressed') === 'true') {
          this.select(button, false);
        }
      }

      render(category, shouldAdvance = true) {
        const pick = this.picks.get(category);
        const slot = this.querySelector(`[data-slot="${category}"]`);
        const image = slot.querySelector('[data-slot-image]');
        image.src = pick.image;
        image.alt = pick.title;
        image.hidden = !pick.image;
        slot.querySelector('[data-slot-title]').textContent = pick.title;
        slot.classList.add('is-filled');
        const totalSteps = this.querySelectorAll('[data-slot]').length;
        const count = this.picks.size;
        const subtotal = [...this.picks.values()].reduce((sum, item) => sum + item.price, 0);
        const complete = count === totalSteps;
        this.querySelector('[data-count]').textContent = count;
        this.querySelector('[data-progress]').style.width = `${(count / totalSteps) * 100}%`;
        this.querySelector('[data-original]').textContent = count ? this.money.format(subtotal / 100) : '—';
        this.querySelector('[data-total]').textContent = complete ? this.money.format((subtotal * .9) / 100) : `${totalSteps - count} pick${totalSteps - count === 1 ? '' : 's'} left`;
        this.querySelector('[data-saving]').textContent = complete ? `You save ${this.money.format((subtotal * .1) / 100)}` : '';
        this.querySelector('[data-status]').textContent = complete ? 'Desk setup complete. Your extra 10% is unlocked!' : `${count} of ${totalSteps} selected. Keep going!`;
        this.addButton.disabled = !complete;
        this.querySelector('[data-add-label]').textContent = complete ? 'Add my desk setup — 10% off' : 'Complete all 4 picks';
        if (!complete && shouldAdvance) {
          const categories = [...this.querySelectorAll('[data-category-section]')];
          const currentIndex = categories.findIndex((item) => item.dataset.categorySection === category);
          const next = categories.slice(currentIndex + 1).find((item) => !this.picks.has(item.dataset.categorySection));
          if (next && window.matchMedia('(max-width: 749px)').matches) {
            window.setTimeout(() => next.scrollIntoView({ behavior: 'smooth', block: 'start' }), 280);
          }
        }
      }

      async addBundle() {
        if (this.addButton.disabled) return;
        this.addButton.disabled = true;
        this.querySelector('[data-add-label]').textContent = 'Building your bundle…';
        this.querySelector('[data-status]').textContent = 'Adding your four picks to cart.';
        const items = [...this.picks.values()].map((item) => ({
          id: item.id,
          quantity: 1,
          properties: { '_Jigzy desk bundle': this.dataset.discountCode }
        }));
        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart request failed');
          const redirect = encodeURIComponent(this.dataset.cartUrl);
          window.location.assign(`/discount/${encodeURIComponent(this.dataset.discountCode)}?redirect=${redirect}`);
        } catch (error) {
          this.addButton.disabled = false;
          this.querySelector('[data-add-label]').textContent = 'Try adding the bundle again';
          this.querySelector('[data-status]').textContent = 'Something went wrong. Your selections are still here.';
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jigzy-clicker-trio-builder"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-clicker-trio]').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const cards = [...root.querySelectorAll('[data-clicker-option]')];
    const slots = [...root.querySelectorAll('[data-slot]')];
    const message = root.querySelector('[data-selection-message]');
    const priceMessage = root.querySelector('[data-price-message]');
    const error = root.querySelector('[data-error]');
    const submit = root.querySelector('[data-add-trio]');
    const bundlePrice = Number(root.dataset.bundlePrice);
    const selected = [];

    const money = (cents) => new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(cents / 100);

    const paint = () => {
      cards.forEach((card) => {
        const index = selected.indexOf(card);
        const active = index > -1;
        card.setAttribute('aria-pressed', String(active));
        card.querySelector('.jctb__number').textContent = active ? String(index + 1) : '';
      });

      slots.forEach((slot, index) => slot.classList.toggle('is-filled', index < selected.length));
      submit.disabled = selected.length !== 3;
      message.textContent = selected.length === 3
        ? root.dataset.readyMessage
        : root.dataset.selectMessage.replace('[count]', String(3 - selected.length));

      if (selected.length === 3) {
        const regularTotal = selected.reduce((total, card) => total + Number(card.dataset.price), 0);
        if (regularTotal > bundlePrice) {
          priceMessage.textContent = `Regular total ${money(regularTotal)} · your trio ${money(bundlePrice)}`;
        } else {
          priceMessage.textContent = `Your picks are already lower at ${money(regularTotal)}—you keep that price.`;
        }
      } else {
        priceMessage.textContent = '';
      }

      error.hidden = true;
    };

    cards.forEach((card) => {
      card.addEventListener('click', () => {
        const index = selected.indexOf(card);
        if (index > -1) {
          selected.splice(index, 1);
        } else if (selected.length < 3) {
          selected.push(card);
        }
        paint();
      });
    });

    submit.addEventListener('click', async () => {
      if (selected.length !== 3) return;
      submit.disabled = true;
      const originalLabel = submit.innerHTML;
      submit.textContent = root.dataset.addingMessage;

      const regularTotal = selected.reduce((total, card) => total + Number(card.dataset.price), 0);
      const selectedNames = selected.map((card) => card.dataset.productTitle);
      const selectedIds = selected.map((card) => Number(card.dataset.variantId));
      const items = regularTotal > bundlePrice
        ? [{
            id: Number(root.dataset.bundleVariantId),
            quantity: 1,
            properties: {
              'Clicker 1': selectedNames[0],
              'Clicker 2': selectedNames[1],
              'Clicker 3': selectedNames[2],
              '_Component variant IDs': selectedIds.join(',')
            }
          }]
        : selectedIds.map((id) => ({ id, quantity: 1 }));

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('Unable to add this trio right now.');
        window.location.href = window.Shopify.routes.root + 'cart';
      } catch (requestError) {
        error.textContent = requestError.message;
        error.hidden = false;
        submit.innerHTML = originalLabel;
        submit.disabled = false;
      }
    });

    paint();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jigzy-latest-stories"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.jigzy-latest:not([data-latest-ready])').forEach((section) => {
      section.setAttribute('data-latest-ready', 'true');
      const track = section.querySelector('.jigzy-latest__track');
      const previous = section.querySelector('[data-latest-previous]');
      const next = section.querySelector('[data-latest-next]');
      const step = () => {
        const card = track.querySelector('.jigzy-story-card');
        return card ? card.getBoundingClientRect().width + 20 : 360;
      };
      previous?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
